<div *ngIf="rulePriceJson.rulesArr.length > 0" class="mob_tabBox">
	<div *ngFor="let innerItem of rulePriceJson.rulesArr" class="tagBox">
	<label class="a-label js-a-label rule-price">{{ innerItem.priceTag}} {{init.formatPrice(innerItem.strategyPrice) | currency:currency}}</label>
	</div>
</div>
